import { createStyles, makeStyles } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const { PRIMARY_CALENDAR_SESSION, DARK_GREEN_CALENDAR_CALLBACK } = COLORS;

export const useStyles = makeStyles(() =>
  createStyles({
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    labelContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: 6,
    },
    vl: {
      height: 20,
      width: 2,
    },
    vlColorSession: {
      backgroundColor: PRIMARY_CALENDAR_SESSION,
    },
    vlColorCallback: {
      backgroundColor: DARK_GREEN_CALENDAR_CALLBACK,
    },
  }),
);
